import { Controller } from "@hotwired/stimulus"
import { createElement } from "react"
import { createRoot } from "react-dom/client"
import { ArticleWriter } from "@/tiptap/article-writer"

export default class extends Controller {
  connect() {
    const el = this.element

    this.root = createRoot(el)
    this.root.render(
      createElement(ArticleWriter, {
        name: el.dataset.name,
        prename: el.dataset.prename,
        id: el.dataset.id,
        activeUserName: el.dataset.activeUserName,
        submitUrl: el.dataset.submitUrl,
        takeoverUrl: el.dataset.takeoverUrl,
        closeUrl: el.dataset.closeUrl,
        autosaveUrl: el.dataset.autosaveUrl,
        precontent: el.dataset.precontent,
        darkMode: el.dataset.darkMode === "true",
        draftTitle: el.dataset.draftTitle,
        lastSaved: el.dataset.lastSaved,
        lastUpdated: el.dataset.lastUpdated,
        articleUrl: el.dataset.articleUrl,
        draftContent: el.dataset.draftContent,
        hasDraft: el.dataset.hasDraft === "true",
        initialFocusTarget: el.dataset.initialFocusTarget || "title",
        folderOptions: JSON.parse(el.dataset.folderOptions || "[]"),
        selectedFolderId: el.dataset.folderValue,
        customCss: el.dataset.customCss,
      }),
    )
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }
}
